<div [formGroup]="formGroup">
  <mat-card>
    <mat-card-header>Canons used in this project</mat-card-header>
    <mat-card-content>
      <mat-selection-list formControlName="canons">
        @for (c of canonNames; track c) {
          <mat-list-option [value]="c">{{ c }}</mat-list-option>
        }
      </mat-selection-list>
    </mat-card-content>
  </mat-card>

  <mat-card>
    <mat-card-header>Frequency Thresholds</mat-card-header>
    <mat-card-content>
      <p>E.g., “Words that occur fewer than ___ times should be glossed.”</p>
      @for (c of canons; track c) {
        <mat-form-field>
          <mat-label>Frequency Threshold for {{c}}</mat-label>
          <input matInput [formControlName]="c" type="number" />
        </mat-form-field>
      }
    </mat-card-content>
  </mat-card>


  @for (c of canons; track c) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>Book names for {{c}}</mat-panel-title>
      </mat-expansion-panel-header>
      
        <div class="autofill-buttons">
          <button mat-button type="button" (click)="autofillEnglish(c)">Auto-fill English</button>
          <button mat-button type="button" (click)="autofillLatin(c)">Auto-fill Latin</button>
        </div>
        
      @for (book of canonData(c).books; track book) {
        <mat-form-field>
          <mat-label>{{englishBookName(book)}}</mat-label>
          <input matInput [formControlName]="book" [appProjectTextStyle]="project" />
        </mat-form-field>
      }
    </mat-expansion-panel>
  }
</div>